import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import legalRule from '@/components/legalRule'
import FAQList from '@/components/FAQList'
import FAQDetail from '@/components/FAQDetail'
import legalRuleDetail from '@/components/legalRuleDetail'
import communityRule from '@/components/communityRule'
import page1 from '@/components/page1'
import news from '@/components/news'
import newsDetail from '@/components/newsDetail'
import newsSource from '@/components/newsSource'
import error from '@/components/error'
import unbindSocial from '@/components/unbindSocial'
import myCollection from '@/components/myCollection'
import timeout from '@/components/timeout'
import municipalInfo from '@/components/municipalInfo'
import municipalInfoDetail from '@/components/municipalInfoDetail'
//import HelloWorld2 from '@/components/HelloWorld2'

import v3search from '@/components/v3/search'
import v3news from '@/components/v3/news'
import v3newsDetail from '@/components/v3/newsDetail'
import v3municipalInfo from '@/components/v3/municipal/municipalInfo'
import v3municipalInfoDetail from '@/components/v3/municipal/municipalInfoDetail'

import newMunicipalInfo from '@/components/v3/newMunicipal/municipalInfo'
import newMunicipalInfoDetail from '@/components/v3/newMunicipal/municipalInfoDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: "今網智生活"
      }
    },
    { // v3 新增
      path: '/v3news',
      name: 'v3news',
      component: v3news,
      meta: {
        title: "充電站",
        keepAlive: true
      }
    },
    { // v3 新增
      path: '/v3search',
      name: 'v3search',
      component: v3search,
      meta: {
        title: "充電站",
        keepAlive: true
      }
    },
    { // v3 新增
      path: '/v3newsDetail/:id',
      name: 'v3newsDetail',
      component: v3newsDetail,
      meta: {
        title: "充電站",
        saveScrollTop:true,
        keepAlive: true
      }
    },
    {
      path: '/page1',
      name: 'page1',
      component: page1,
      meta: {
        title: "測試頁面"
      }
    },
    {
      path: '/legalRule',
      name: 'legalRule',
      component: legalRule,
      meta: {
        title: "法規查詢"
      }
    },
    {
      path: '/legalRuleDetail/:id',
      name: 'legalRuleDetail',
      component: legalRuleDetail,
      meta: {
        title: "法規查詢"
      }
    },
    {
      path: '/FAQList',
      name: 'FAQList',
      component: FAQList,
      meta: {
        title: "法律問答"
      }
    },
    {
      path: '/FAQDetail/:id',
      name: 'FAQDetail',
      component: FAQDetail,
      meta: {
        title: "法律問答"
      }
    },
    {
      path: '/communityRule',
      name: 'communityRule',
      component: communityRule,
      meta: {
        title: "規約範本"
      }
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: {
        title: "全部文章",
        keepAlive: true
      }
    },
    {
      path: '/newsDetail/:id',
      name: 'newsDetail',
      component: newsDetail,
      meta: {
        title: "\u200E",  //空白
        saveScrollTop:true,
        keepAlive: true
      }
    },
    {
      path: '/newsSource/:id',
      name: 'newsSource',
      component: newsSource,
      meta: {
        title: "\u200E"  //空白
      }
    },
    {
      path: '/error',
      name: 'error',
      component: error,
      meta: {
        title: "今網智生活-Error"
      }
    },
    {
      path: '/myCollection/:page',
      name: 'myCollection',
      component: myCollection,
      meta: {
        title: "我的收藏"
      }
    },
    {
      path: '/unbindSocial',
      name: 'unbindSocial',
      component: unbindSocial,
      meta: {
        title: "今網智生活-Error"
      }
    },
    {
      path: '/timeout',
      name: 'timeout',
      component: timeout,
      meta: {
        title: "今網智生活-Error"
      }
    },
    {
      path: '/municipalInfo',
      name: 'municipalInfo',
      component: municipalInfo,
      meta: {
        title: "新北市政資訊",
        keepAlive: true
      }
    },
    {
      path: '/municipalInfoDetail/:type/:id/:aaa?',
      name: 'municipalInfoDetail',
      component: municipalInfoDetail,
      meta: {
        title: "\u200E"  //空白
      }
    },
    { // v3 新增
      path: '/v3municipalInfo',
      name: 'v3municipalInfo',
      component: v3municipalInfo,
      meta: {
        title: "新北市政資訊",
        keepAlive: true
      }
    },
    { // v3 新增
      path: '/v3municipalInfoDetail/:type/:id/:aaa?',
      name: 'v3municipalInfoDetail',
      component: v3municipalInfoDetail,
      meta: {
        title: "新北市政資訊"
      }
    },
    { // new新北資料
      path: '/newMunicipalInfoDetail/:type/:id/:idx',
      name: 'newMunicipalInfoDetail',
      component: newMunicipalInfoDetail,
      meta: {
        title: "新北市最新消息"
      }
    },
    {
      path: '/newMunicipalInfo',
      name: 'newMunicipalInfo',
      component: newMunicipalInfo,
      meta: {
        title: "新北市最新消息",
        keepAlive: true
      }
    }

    // ,
    // {
    //   path: '/HelloWorld2',
    //   name: 'HelloWorld2',
    //   component: HelloWorld2,
    //   meta: {
    //     title: "今網智生活-debug"
    //   }
    // }
  ],
  scrollBehavior (to, from, savedPosition) {
    // console.log(savedPosition)
    // if (savedPosition) {
    //   return savedPosition
    // } else {
    //   return { x: 0, y: 0 }
    // }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js